import { Chip } from "@mui/material";
import { type FieldProps } from "react-admin";

import { useTypedFieldValue } from "@/hooks";

export const ArrayOfStrings = <RecordType extends Record<string, unknown>>(
  props: FieldProps<RecordType>,
) => {
  const value = useTypedFieldValue<unknown[], RecordType>(props);

  if (!Array.isArray(value)) {
    return "-";
  }

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-start",
        flexWrap: "wrap",
        gap: 4,
      }}
    >
      {value.map((item, index) => (
        <Chip key={index} label={String(item)} size="small" />
      ))}
    </div>
  );
};
